import { Injectable } from '@angular/core';
import { TriggerInterface } from 'app/models/trigger.model';
import { TimeslotInterface, TimeslotMinutesItemInterface } from 'app/modules/common/timeslot/timeslot.interface';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import {
  TriggerContentsItemInterface,
  TriggerPeriodicalInterface,
  TriggerTimeInterface,
  TriggerTimeScheduleInterface,
} from '../../trigger.interface';

@Injectable({
  providedIn: 'root',
})
export class TriggerDataTransformGet extends DataTransformAbstractGet {
  transform(trigger: TriggerInterface): TriggerInterface {
    if (trigger.startAt) {
      trigger.startAt = this.removeUTC(trigger.startAt.toString());
    }
    if (trigger.endAt) {
      trigger.endAt = this.removeUTC(trigger.endAt.toString());
    }
    trigger.contents = this.normalizeContents(trigger.contents);
    return trigger;
  }

  protected normalizeContents(contents: TriggerContentsItemInterface[]): TriggerContentsItemInterface[] {
    if (!Array.isArray(contents)) {
      return contents;
    }
    contents.forEach((item: TriggerContentsItemInterface) => {
      this.normalizeTimeslots(item.timeslots);
      this.normalizePeriodical(item.periodical);
      this.normalizeBehaviorTime(item.time);
    });
    return contents;
  }

  protected normalizeBehaviorTime(time: TriggerTimeInterface): TriggerTimeInterface {
    if (time) {
      this.normalizeBehaviorTimeSchedules(time.schedules);
    }
    return time;
  }

  protected normalizeBehaviorTimeSchedules(schedules: TriggerTimeScheduleInterface[]): TriggerTimeScheduleInterface[] {
    if (!Array.isArray(schedules)) {
      return schedules;
    }
    schedules.forEach((item: TriggerTimeScheduleInterface) => {
      item.time = this.removeUTC(item.time.toString());
    });
    return schedules;
  }

  protected normalizePeriodical(periodical: TriggerPeriodicalInterface): TriggerPeriodicalInterface {
    if (periodical) {
      this.normalizePeriodicalTimes(periodical.times);
    }
    return periodical;
  }

  protected normalizePeriodicalTimes(times: TimeslotMinutesItemInterface[]): TimeslotMinutesItemInterface[] {
    if (!Array.isArray(times)) {
      return times;
    }
    times.forEach((item: TimeslotMinutesItemInterface) => {
      if (!item.timeslots) {
        item.timeslots = {
          from: null,
          to: null,
          alwaysOn: true,
        };
      }
      this.normalizeTimeslot(item.timeslots);
    });
    return times;
  }

  protected normalizeTimeslots(timeslots: TimeslotInterface[]): TimeslotInterface[] {
    if (!Array.isArray(timeslots)) {
      return timeslots;
    }
    timeslots.forEach((timeslot: TimeslotInterface) => {
      this.normalizeTimeslot(timeslot);
    });
    return timeslots;
  }

  protected normalizeTimeslot(timeslot: TimeslotInterface): TimeslotInterface {
    if (timeslot.from) {
      timeslot.from = this.removeUTC(timeslot.from.toString());
    }
    if (timeslot.to) {
      timeslot.to = this.removeUTC(timeslot.to.toString());
    }
    return timeslot;
  }
}
